module.exports = __webpack_public_path__ + "img/maipu-automotores.8c87f08b.jpg";